import { ChangeDetectionStrategy, Component, OnInit, OnDestroy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { Title } from '@angular/platform-browser';
import { SessionMonitorService } from './core/auth/session-monitor.service';
import { APP_BRANDING } from './core/config/branding.config';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App implements OnInit, OnDestroy {
  private titleService = inject(Title);
  private sessionMonitor = inject(SessionMonitorService);

  ngOnInit(): void {
    this.titleService.setTitle(APP_BRANDING.browserTitle);
    this.sessionMonitor.start();
  }

  ngOnDestroy(): void {
    this.sessionMonitor.stop();
  }
}
